<template>
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512.001 512.001"
    style="enable-background:new 0 0 512.001 512.001;"
    xml:space="preserve"
  >
    <path
      style="fill:#FAE17C;"
      d="M219.313,453.038C23.334,487.83,6.562,340.065,13.049,264.09c0.565-6.622,6.971-11.15,13.379-9.39
	c13.924,3.823,27.076,10.16,34.72,17.119c1.89,1.721,4.879,0.097,4.461-2.426C58.805,228.339,48.27,141.917,75.916,81.288
	c3.887-8.525,13.939-12.296,22.448-8.375c25.41,11.711,61.865,44.708,75.645,66.439c2.077,3.276,7.063,2.412,7.91-1.374
	c6.792-30.34,23.79-74.788,42.879-96.316c6.667-7.518,18.396-7.806,25.337-0.54c19.808,20.735,39.684,57.955,45.952,78.732
	c0.977,3.237,5.373,3.766,7.091,0.854c14.035-23.797,40.89-43.343,61.194-54.58c9.352-5.176,20.906,1.164,21.632,11.829
	c3.31,48.662,0.391,162.157-21.17,217.958c-1.265,3.274,2.259,6.348,5.334,4.656c14.597-8.032,43.075-20.886,72.405-18.512
	c4.596,0.372,8.749,2.875,11.392,6.653c40.693,58.147,45.479,147.956-76.666,168.675
	C326.734,465.962,289.242,440.624,219.313,453.038z"
    />
    <path
      style="opacity:0.05;enable-background:new    ;"
      d="M387.096,108.317c-4.023-0.676-8.144-1.041-12.341-1.041
	c-4.306,0-8.654,0.382-12.924,1.135l-24.794,4.372c-2.739,0.483-5.536,0.728-8.314,0.728c-6.257,0-12.413-1.259-18.124-3.599
	c-2.736,3.486-5.234,7.09-7.42,10.797c-1.718,2.913-6.114,2.384-7.091-0.854c-2.579-8.551-7.467-19.887-13.702-31.712
	c-17.246-13.203-38.598-20.571-60.515-20.571c-4.926,0-9.878,0.394-14.762,1.127c-11.378,21.937-20.605,48.811-25.187,69.276
	c-0.848,3.788-5.836,4.653-7.915,1.375c-8.92-14.064-27.336-32.842-46.108-47.518c-10.468,7.087-19.659,16.101-27.127,26.767
	c-16.075,22.958-22.248,50.802-17.381,78.403l7.535,42.731c3.442,19.523,12.873,37.391,26.877,51.211
	c-8.029,13.494-12.557,28.495-13.263,44.032C88.53,345.584,65.984,351.6,41.764,351.601c-6.922,0-14.04-0.482-21.161-1.432
	c-0.568-0.076-1.139-0.123-1.708-0.155c5.015,20.046,13.209,39.7,26.004,56.643c33.344,11.819,68.712,15.257,98.457,16.643
	c0.074,0.035,0.148,0.07,0.223,0.105c0.376,11.841,0.402,24.231,0.018,29.223c-0.121,1.574-0.126,3.14-0.018,4.686
	c18.484,1.726,39.463,1.137,63.242-2.273c0.13-3.827,0.283-11.403,0.241-20.339c1.412,0.019,2.834,0.028,4.266,0.028
	c3.075,0,6.09-0.042,9.031-0.125c0.103,7.878,0.025,14.641-0.236,18.022c-0.007,0.094-0.008,0.187-0.015,0.281
	c24.432-4.252,44.897-3.899,63.358-2.025c0.151-6.947,0.235-18.21-0.095-29.646c10.834-5.897,18.89-13.784,24.516-23.965
	c4.751-8.6,7.703-18.744,9.156-31.596c8.806-5.153,21.269-13.977,30.105-26.538c7.697-10.944,5.056-26.11-5.887-33.808
	c-4.11-2.891-8.933-4.42-13.947-4.42c-5.548,0-10.863,1.902-15.108,5.272c-1.037-2.758-2.205-5.469-3.504-8.133l59.064-10.415
	C383.233,240.065,387.713,160.896,387.096,108.317z"
    />
    <path
      style="fill:#498A68;"
      d="M301.056,360.527c-4.941,0-9.714-2.677-12.164-7.358c-3.513-6.712-0.919-14.999,5.792-18.512
	c4.368-2.286,15.196-8.555,21.395-17.368c4.359-6.195,12.915-7.685,19.109-3.328c6.196,4.358,7.686,12.913,3.328,19.109
	c-9.305,13.228-23.487,21.899-31.112,25.891C305.375,360.023,303.199,360.527,301.056,360.527z"
    />
    <path
      style="fill:#5CB38E;"
      d="M203.831,413.723c-64.004,0-137.661,0-191.584-34.427c-9.228-5.891-3.891-20.119,6.961-18.67
	c42.702,5.701,78.571-5.169,99.024-22.777L203.831,413.723z"
    />
    <path
      style="opacity:0.1;enable-background:new    ;"
      d="M94.087,352.374c0.714,20.44,3.851,40.843,16.45,57.809
	c31.202,3.54,63.306,3.541,93.292,3.541L118.23,337.85C111.674,343.493,103.528,348.438,94.087,352.374z"
    />
    <g>
      <path
        style="fill:#498A68;"
        d="M175.177,476.156c-0.544,0-1.09-0.021-1.641-0.063c-11.62-0.893-20.314-11.038-19.42-22.656
		c0.811-10.545-0.059-45.712-1.572-53.501c-3.472-10.456,1.72-21.955,12.07-26.172c10.795-4.397,23.106,0.788,27.503,11.579
		c5.69,13.964,4.336,67.953,4.076,71.331C195.342,467.74,186.095,476.155,175.177,476.156z M153.026,401.242
		c0.003,0.008,0.007,0.016,0.01,0.024C153.033,401.258,153.029,401.25,153.026,401.242z"
      />
      <path
        style="fill:#498A68;"
        d="M251.703,476.156c-0.543,0-1.09-0.021-1.641-0.063c-11.62-0.893-20.314-11.038-19.42-22.656
		c0.811-10.545-0.059-45.712-1.572-53.501c-3.473-10.456,1.72-21.955,12.069-26.172c10.791-4.397,23.106,0.786,27.503,11.579
		c5.69,13.964,4.336,67.953,4.076,71.331C271.867,467.74,262.62,476.155,251.703,476.156z M229.552,401.242
		c0.003,0.008,0.007,0.016,0.01,0.024C229.558,401.258,229.555,401.25,229.552,401.242z"
      />
    </g>
    <path
      style="opacity:0.1;enable-background:new    ;"
      d="M273.044,437.118c-0.017-17.935-0.791-42.914-4.402-51.776
	c-4.397-10.793-16.712-15.975-27.503-11.579c-10.351,4.218-15.542,15.717-12.07,26.172c1.213,6.245,2.012,30.086,1.863,44.728
	C247.223,443.594,261.181,441.105,273.044,437.118z"
    />
    <path
      style="opacity:0.1;enable-background:new    ;"
      d="M164.614,373.763c-10.351,4.218-15.542,15.717-12.07,26.172
	c1.057,5.443,1.8,24.253,1.875,38.69c11.972,3.462,25.926,5.539,42.06,6.307c0.195-17.536-0.186-49.343-4.362-59.592
	C187.72,374.551,175.409,369.366,164.614,373.763z"
    />
    <path
      style="fill:#5CB38E;"
      d="M307.663,339.274c0,49.261-6.691,84.906-96.336,84.906s-96.336-35.645-96.336-84.906
	s43.131-89.194,96.336-89.194C264.532,250.079,307.663,290.013,307.663,339.274z"
    />
    <path
      style="fill:#9BDFC1;"
      d="M307.664,339.274c0-0.393-0.011-0.783-0.016-1.174c-20.065-5.15-59.866-6.647-87.561,22.787
	c-20.183,21.449-23.103,44.595-20.938,63.054c3.88,0.158,7.936,0.238,12.179,0.238C300.973,424.179,307.664,388.535,307.664,339.274
	z"
    />
    <path
      style="opacity:0.05;enable-background:new    ;"
      d="M193.039,251.691c-44.458,7.912-78.048,44.112-78.048,87.582
	c0,45.613,5.748,79.547,77.766,84.324C152.771,383.011,160.504,299.209,193.039,251.691z"
    />
    <path
      style="fill:#5CB38E;"
      d="M286.339,105.839L286.339,105.839c-20.52-21.642-50.531-31.546-79.902-26.367l-36.105,6.367
	c-51.33,9.051-85.604,58-76.553,109.33l7.535,42.731c8.123,46.068,52.054,76.829,98.122,68.706l191.389-33.747
	c34.511-6.086,57.555-38.994,51.469-73.506l-5.128-29.082c-6.085-34.511-38.994-57.555-73.506-51.469l-24.794,4.372
	C319.559,126.577,299.83,120.067,286.339,105.839z"
    />
    <ellipse
      transform="matrix(-0.1736 -0.9848 0.9848 -0.1736 219.7385 615.0205)"
      style="fill:#495059;"
      cx="367.913"
      cy="215.315"
      rx="32.668"
      ry="35.831"
    />
    <g style="opacity:0.1;">
      <circle cx="155.385" cy="249.31" r="6.495" />
      <circle cx="202.573" cy="251.05" r="6.495" />
      <circle cx="180.404" cy="277.449" r="6.495" />
    </g>
    <path
      style="opacity:0.05;enable-background:new    ;"
      d="M150.092,91.785c-39.736,16.688-64.111,59.15-56.313,103.383l7.535,42.731
	c8.123,46.068,52.054,76.829,98.122,68.706l50.616-8.925C168.775,267.788,135.491,152.093,150.092,91.785z"
    />
    <path
      style="fill:#498A68;"
      d="M184.875,367.858c-1.885,0-3.8-0.391-5.631-1.216c-16.088-7.257-26.164-19.981-29.474-24.164
	l-0.24-0.303c-4.712-5.931-3.724-14.558,2.208-19.27c5.931-4.712,14.559-3.724,19.27,2.208l0.269,0.339
	c2.286,2.887,9.242,11.674,19.245,16.185c6.905,3.115,9.978,11.238,6.864,18.141C195.097,364.853,190.103,367.858,184.875,367.858z"
    />
    <g>
      <path
        style="fill:#FFFFFF;"
        d="M354.095,340.606c-0.79-2.058,0.238-4.367,2.296-5.157l11.76-4.514
		c4.308-1.654,8.111-1.726,11.192-0.354c2.613,1.163,4.65,3.435,5.876,6.629l0.037,0.097c2.044,5.324,0.645,9.636-2.818,12.908
		l7.593,4.304c1.079,0.641,1.86,1.23,2.306,2.391c0.799,2.081-0.423,4.105-2.214,4.792c-1.693,0.65-3.122,0.255-4.421-0.523
		l-9.6-5.703c-0.751-0.446-1.665-0.524-2.48-0.211l-2.976,1.142c-0.931,0.357-1.396,1.402-1.039,2.333l2.127,5.541
		c0.778,2.026-0.075,4.409-2.067,5.269c-2.123,0.916-4.499-0.095-5.318-2.23L354.095,340.606z M373.983,347.574
		c3.63-1.393,4.968-4.128,3.872-6.983l-0.037-0.097c-1.226-3.194-4.084-3.985-7.714-2.592l-5.641,2.165
		c-0.974,0.374-1.461,1.467-1.087,2.441l2.38,6.199c0.374,0.974,1.467,1.461,2.441,1.087L373.983,347.574z"
      />
      <path
        style="fill:#FFFFFF;"
        d="M397.412,352.19l15.797-28.316c1.099-1.952,2.874-3.032,5.124-2.824l0.482,0.045
		c2.25,0.208,3.744,1.589,4.467,3.709l10.35,30.729c0.58,1.671,0.401,2.868-1.692,4.583c-0.644,0.528-1.484,0.798-2.314,0.721
		c-1.927-0.179-3.109-1.422-3.7-3.205l-1.139-3.535c-0.507-1.572-1.902-2.69-3.546-2.842l-11.078-1.022
		c-1.646-0.152-3.223,0.694-4.008,2.148l-1.9,3.521c-0.845,1.543-2.328,2.379-4.042,2.22c-2.143-0.198-3.646-2.066-3.448-4.208
		C396.821,353.325,397.09,352.755,397.412,352.19z M421.119,342.503l-2.887-9.152c-0.267-0.845-1.42-0.952-1.836-0.169l-4.512,8.469
		c-0.336,0.631,0.079,1.4,0.791,1.466l7.399,0.683C420.785,343.864,421.334,343.184,421.119,342.503z"
      />
      <path
        style="fill:#FFFFFF;"
        d="M350.479,379.224c-0.123-0.454-0.24-1.006-0.215-1.451c0.123-2.126,1.994-3.605,4.121-3.483
		c1.78,0.103,3.148,1.323,3.551,2.934l4.814,18.411c0.264,1.01,1.666,1.094,2.049,0.123l6.922-17.541
		c0.696-1.745,2.103-2.905,4.031-2.793l0.594,0.034c1.928,0.111,3.195,1.375,3.683,3.239l4.859,18.221
		c0.269,1.009,1.671,1.086,2.049,0.113l6.899-17.735c0.58-1.455,1.937-2.617,3.816-2.508c2.077,0.12,3.667,1.799,3.547,3.876
		c-0.026,0.445-0.209,1.029-0.383,1.466l-11.26,26.636c-0.803,1.888-2.307,2.992-4.136,2.886l-0.791-0.046
		c-1.83-0.106-3.149-1.323-3.727-3.34l-4.57-16.272c-0.363-1.293-2.156-1.396-2.665-0.154l-6.412,15.639
		c-0.806,1.937-2.256,2.995-4.086,2.889l-0.792-0.046c-1.829-0.106-3.195-1.375-3.776-3.343L350.479,379.224z"
      />
      <path
        style="fill:#FFFFFF;"
        d="M408.596,376.101c-0.383-2.208,1.096-4.308,3.304-4.691l12.614-2.188
		c4.621-0.801,8.428-0.125,11.23,1.849c2.376,1.674,3.961,4.34,4.556,7.766l0.018,0.104c0.99,5.711-1.253,9.736-5.35,12.318
		l6.725,5.786c0.949,0.851,1.613,1.592,1.829,2.838c0.387,2.232-1.23,4.01-3.151,4.343c-1.816,0.315-3.163-0.36-4.305-1.392
		l-8.468-7.59c-0.65-0.583-1.532-0.836-2.393-0.687l-3.244,0.563c-0.983,0.17-1.641,1.105-1.471,2.088l1.036,5.973
		c0.377,2.173-0.942,4.382-3.098,4.847c-2.297,0.496-4.467-0.98-4.865-3.27L408.596,376.101z M427.058,386.963
		c3.894-0.675,5.766-3.139,5.235-6.202l-0.018-0.104c-0.594-3.426-3.288-4.777-7.182-4.102l-6.082,1.055
		c-1.028,0.178-1.717,1.156-1.539,2.185l1.164,6.711c0.178,1.028,1.156,1.717,2.185,1.539L427.058,386.963z"
      />
    </g>
    <path
      d="M471.999,322.226c-3.95,1.247-6.142,5.46-4.895,9.41c5.938,18.814,9.815,46.479-5.435,71.433
	c-14.656,23.984-43.465,39.77-85.625,46.922c-21.894,3.715-40.959,0.763-63.036-2.654c-10.335-1.6-20.976-3.235-32.487-4.258
	c0.053-6.84,0.012-15.316-0.259-23.653c7.5-3.841,13.643-8.612,18.552-14.355c9.865-11.543,13.818-26.026,15.373-41.27
	c8.586-4.871,21.494-13.665,30.464-26.417c6.73-9.569,4.42-22.828-5.148-29.558c-9.145-6.434-21.646-4.59-28.613,3.939
	c-1.75-5.501-4.032-10.851-6.821-15.994l56.388-9.943c-0.854,2.601-1.728,5.072-2.621,7.383c-1.725,4.464-0.51,9.385,3.096,12.537
	c2.124,1.856,4.744,2.81,7.396,2.81c1.855,0,3.726-0.467,5.454-1.417c13.685-7.531,40.74-19.832,68.185-17.608
	c2.303,0.186,4.437,1.454,5.853,3.478c1.95,2.787,3.827,5.672,5.579,8.576c2.14,3.545,6.749,4.688,10.296,2.547
	c3.546-2.14,4.687-6.75,2.547-10.296c-1.926-3.192-3.99-6.364-6.134-9.428c-3.987-5.698-10.159-9.28-16.931-9.828
	c-26.289-2.126-51.722,7.107-68.182,15.06c0.7-2.166,1.381-4.421,2.047-6.74l15.086-2.66c38.528-6.794,64.346-43.665,57.553-82.194
	l-5.128-29.083c-4.832-27.401-24.882-48.358-49.916-55.743c-0.073-13.431-0.466-25.704-1.152-35.778
	c-0.517-7.596-4.817-14.304-11.505-17.946c-6.666-3.631-14.606-3.606-21.241,0.065c-12.058,6.674-40.628,24.219-58.794,49.38
	c-0.786-0.487-1.556-1.002-2.317-1.533c-8.697-21.897-26.245-52.811-44.071-71.471c-4.731-4.953-11.39-7.71-18.267-7.593
	c-6.921,0.129-13.519,3.168-18.104,8.339c-7.668,8.648-15.541,21.375-22.888,36.957l-27.268,4.808
	c-11.331,1.998-22.042,5.818-31.816,11.239c-12.853-10.533-25.398-18.835-35.712-23.588c-5.926-2.731-12.557-2.984-18.673-0.712
	c-6.139,2.279-11.018,6.821-13.737,12.786c-24.215,53.106-20.845,125.667-12.68,180.972c-7.832-4.707-17.634-8.835-27.999-11.681
	c-5.191-1.425-10.701-0.475-15.118,2.606c-4.444,3.099-7.257,7.975-7.719,13.377c-1.972,23.095-2.252,56.721,6.576,90.449
	c-5.004,1.628-9.07,5.457-11.026,10.806c-2.905,7.947-0.058,16.35,7.085,20.91c6.913,4.413,14.097,8.252,21.456,11.607
	c24.135,41.447,64.044,64.312,118.74,67.999c1.16,3.044,2.849,5.898,5.032,8.445c4.972,5.8,11.906,9.317,19.514,9.902
	c0.734,0.057,1.482,0.086,2.225,0.086c12.784-0.001,23.838-8.616,27.383-20.469c5.931-0.76,11.984-1.684,18.062-2.764
	c0.949-0.168,1.904-0.33,2.865-0.487c0.862,5.032,3.068,9.756,6.477,13.732c4.972,5.8,11.905,9.317,19.513,9.902
	c0.733,0.058,1.482,0.087,2.225,0.087c14.551-0.001,26.86-11.157,28.406-25.551c10.717,0.99,20.802,2.538,30.606,4.056
	c14.95,2.314,29.344,4.542,44.491,4.542c7.542,0,15.273-0.553,23.348-1.922c46.626-7.91,78.897-26.041,95.915-53.89
	c14.193-23.226,16.658-52.977,6.94-83.77C480.161,323.171,475.951,320.979,471.999,322.226z M322.214,321.603
	c1.973-2.804,5.858-3.48,8.661-1.509c2.804,1.972,3.48,5.857,1.509,8.661c-4.883,6.941-11.332,12.523-17.257,16.711
	c0.027-2.068,0.038-4.134,0.038-6.193c0-3.123-0.176-6.227-0.493-9.307C317.681,327.254,320.21,324.452,322.214,321.603z
	 M368.003,72.69c3.059-1.692,5.777-0.575,6.804-0.017c1.037,0.565,3.474,2.259,3.714,5.793c0.618,9.072,0.991,20.025,1.098,32.048
	c-5.651-0.395-11.435-0.125-17.258,0.902l-24.793,4.372c-7.238,1.277-14.517,0.957-21.405-0.795
	C333.239,93.003,359.632,77.322,368.003,72.69z M230.41,46.639c1.838-2.072,4.38-3.241,7.16-3.293c2.73-0.03,5.273,1,7.143,2.957
	c9.541,9.987,19.198,24.208,27.172,38.309c-17.129-10.425-37.182-15.293-57.47-13.701C219.737,60.815,225.172,52.545,230.41,46.639z
	 M20.52,264.729c0.111-1.302,0.895-2.031,1.352-2.35c0.442-0.308,1.366-0.777,2.569-0.446c12.987,3.566,25.118,9.48,31.657,15.433
	c3.21,2.921,7.922,3.494,11.73,1.421c3.808-2.071,5.889-6.338,5.18-10.618c-16.316-98.462-3.713-154.281,9.733-183.768
	c1.053-2.311,2.939-4.068,5.312-4.948c2.349-0.873,4.897-0.777,7.174,0.273c8.261,3.807,18.303,10.312,28.864,18.648
	c-7.894,6.165-14.912,13.536-20.819,21.973c-15.607,22.291-21.601,49.325-16.876,76.123l7.535,42.731
	c3.537,20.06,13.545,37.87,27.776,51.225c-8.836,14.021-13.685,29.817-14.16,46.185c-19.805,13.762-48.933,20.087-79.812,17.403
	C18.347,321.071,18.575,287.519,20.52,264.729z M16.282,372.975c-1.189-0.759-1.548-1.808-1.069-3.119
	c0.349-0.956,1.143-2.043,3.001-1.797c33.216,4.433,65.593-0.768,89.556-13.975c0.825,18.209,3.954,35.996,15.104,49.813
	C87.979,400.932,48.57,393.588,16.282,372.975z M146.79,450.048c-39.957-3.233-70.894-17.802-92.317-43.433
	c30.66,9.497,62.526,12.421,89.632,13.662c0.806,0.387,1.624,0.765,2.46,1.132C146.948,432.21,147.036,443.582,146.79,450.048z
	 M188.715,456.098c-0.541,7.042-6.488,12.558-13.537,12.558c-0.351,0-0.703-0.013-1.066-0.042c-3.622-0.278-6.919-1.951-9.283-4.709
	c-2.365-2.758-3.513-6.272-3.234-9.895c0.431-5.606,0.407-16.828,0.132-27.471c8.042,2.055,17.101,3.481,27.255,4.299
	C189.13,444.075,188.799,454.949,188.715,456.098z M223.432,444.76c-1.837,0.28-3.641,0.576-5.43,0.893
	c-4.725,0.839-9.423,1.569-14.06,2.208c0.071-4.45,0.109-10.114,0.049-16.268c2.397,0.054,4.838,0.085,7.339,0.085
	c4.154,0,8.163-0.075,12.03-0.225C223.447,436.335,223.472,440.934,223.432,444.76z M265.24,456.098
	c-0.541,7.042-6.488,12.558-13.537,12.558c-0.35,0-0.703-0.013-1.066-0.042c-3.622-0.278-6.919-1.951-9.283-4.709
	c-2.364-2.758-3.513-6.272-3.234-9.895c0.049-0.631,0.089-1.352,0.126-2.117c0.001-0.012,0.001-0.025,0.002-0.037
	c0.255-5.312,0.244-13.55,0.091-21.441c10.157-1.043,19.154-2.741,27.078-5.117C265.743,440.551,265.358,454.496,265.24,456.098z
	 M270.291,407.622c-0.45,0.144-0.881,0.329-1.289,0.551c-9.923,4.183-22.634,6.778-38.482,7.882
	c-0.029,0.001-0.058-0.003-0.087-0.002c-0.2,0.006-0.396,0.027-0.592,0.048c-5.759,0.384-11.918,0.578-18.513,0.578
	c-4.98,0-9.715-0.109-14.215-0.327c-0.195-0.019-0.392-0.028-0.591-0.032c-16.043-0.816-29.059-3.047-39.376-6.782
	c-0.431-0.21-0.885-0.38-1.357-0.506c-2.05-0.787-3.99-1.635-5.821-2.548c-0.339-0.21-0.699-0.39-1.072-0.545
	c-5.565-2.917-10.091-6.445-13.652-10.613c-7.874-9.212-12.752-21.802-12.752-56.053c0-13.91,3.805-27.401,11.04-39.433
	c8.578,5.748,18.168,10.1,28.451,12.72c-5.422-0.453-10.73,1.142-14.998,4.556c-4.425,3.54-7.207,8.591-7.833,14.223
	c-0.626,5.633,0.98,11.172,4.514,15.589l0.239,0.299c3.606,4.523,14.577,18.288,32.36,26.235c2.747,1.228,5.656,1.85,8.648,1.85
	h0.073c4.142-0.014,7.488-3.383,7.475-7.525c-0.014-4.134-3.369-7.475-7.5-7.475h-0.026c-0.869-0.011-1.734-0.18-2.549-0.545
	c-14.449-6.458-23.709-18.073-26.754-21.894l-0.247-0.31c-1.037-1.296-1.507-2.919-1.324-4.569c0.184-1.65,0.999-3.13,2.295-4.167
	c1.297-1.037,2.925-1.506,4.57-1.324c1.65,0.183,3.13,0.998,4.161,2.288l0.271,0.34c2.578,3.232,10.421,13.066,22.1,18.287
	c1.089,0.487,2.008,1.266,2.656,2.253c2.273,3.463,6.923,4.427,10.385,2.155c3.463-2.273,4.428-6.923,2.155-10.385
	c-2.225-3.389-5.362-6.058-9.075-7.717c-8.349-3.731-14.479-11.419-16.498-13.95l-0.275-0.345c-2.462-3.079-5.666-5.339-9.279-6.654
	c0.553,0.105,1.102,0.223,1.659,0.318c0.428,0.073,0.854,0.108,1.273,0.108c3.587,0,6.759-2.582,7.384-6.236
	c0.698-4.083-2.045-7.959-6.128-8.657c-32.041-5.481-57.364-30.684-63.01-62.713l-7.535-42.731
	c-4.03-22.853,1.081-45.907,14.391-64.916c6.646-9.491,14.939-17.405,24.422-23.454c0.257-0.135,0.505-0.288,0.748-0.453
	c9.324-5.814,19.762-9.853,30.909-11.819l31.065-5.478c0.005-0.001,0.01-0.002,0.015-0.003l5.024-0.886
	c26.966-4.757,54.316,4.269,73.157,24.141c15.265,16.1,37.421,23.412,59.274,19.56l24.793-4.372
	c30.385-5.358,59.46,15.002,64.817,45.385l5.128,29.083c5.358,30.383-15.002,59.46-45.385,64.817l-185.646,32.735
	c-4.079,0.719-6.803,4.609-6.084,8.689c0.719,4.08,4.612,6.806,8.688,6.084l81.845-14.431c7.751,12.358,11.839,26.341,11.839,40.726
	c0,25.394-2.133,43.627-12.753,56.053C283.135,400.329,277.477,404.414,270.291,407.622z M510.615,253.885l-6.18-8.702
	c-2.386-3.359-7.037-4.165-10.414-1.802l-7.352,5.144l-3.678-10.394c-0.74-2.09-2.367-3.747-4.444-4.523
	c-2.079-0.777-4.392-0.594-6.321,0.498l-12.361,6.998c-3.604,2.041-4.873,6.617-2.832,10.222s6.619,4.873,10.222,2.832l4.579-2.592
	l3.984,11.26c0.781,2.208,2.55,3.925,4.781,4.64c0.749,0.24,1.521,0.358,2.289,0.358c1.52,0,3.024-0.462,4.3-1.355l9.331-6.528
	l1.868,2.63c2.398,3.377,7.081,4.169,10.458,1.772C512.22,261.943,513.013,257.262,510.615,253.885z M424.296,108.486l23.503,4.18
	c0.437,0.078,0.876,0.116,1.313,0.116c1.648,0,3.266-0.544,4.589-1.568c1.674-1.295,2.724-3.237,2.888-5.348l1.451-18.558
	l16.081-0.552c2.119-0.073,4.108-1.039,5.475-2.659c1.367-1.62,1.985-3.743,1.7-5.844l-2.49-18.361
	c-0.556-4.104-4.329-6.982-8.44-6.424c-4.104,0.557-6.981,4.335-6.424,8.44l1.375,10.143l-14.49,0.497
	c-3.814,0.131-6.922,3.106-7.22,6.911l-1.328,16.991l-15.357-2.731c-4.077-0.727-7.972,1.993-8.697,6.071
	S420.218,107.761,424.296,108.486z M466.68,154.75c-1.986,0.781-3.545,2.372-4.287,4.374l-5.875,15.856
	c-1.439,3.884,0.543,8.199,4.427,9.638c0.859,0.318,1.739,0.469,2.604,0.469c3.047,0,5.913-1.872,7.034-4.897l2.962-7.994
	l14.93,7.514c1.831,0.921,3.958,1.052,5.887,0.366c1.93-0.687,3.495-2.133,4.331-4.003l8.11-18.128
	c1.691-3.781-0.002-8.217-3.784-9.909c-3.782-1.694-8.218,0.003-9.909,3.784l-4.904,10.964l-15.409-7.755
	C470.891,154.069,468.665,153.968,466.68,154.75z M225.833,121.857l1.356,7.688c0.642,3.639,3.806,6.199,7.377,6.199
	c0.432,0,0.871-0.038,1.311-0.115c4.079-0.72,6.803-4.61,6.083-8.689l-1.417-8.034c-0.213-1.206-0.707-2.288-1.396-3.203
	l5.679-3.279c3.587-2.071,4.816-6.658,2.745-10.245c-2.071-3.587-6.66-4.815-10.245-2.745l-14.66,8.465
	c-3.587,2.071-4.816,6.658-2.745,10.245C221.203,120.366,223.454,121.669,225.833,121.857z M171.477,116.924l-16.671-2.94
	c-4.076-0.72-7.969,2.004-8.688,6.084c-0.719,4.079,2.004,7.969,6.084,8.688l6.459,1.139c-0.335,1.096-0.43,2.282-0.217,3.488
	l1.416,8.034c0.642,3.639,3.806,6.199,7.378,6.199c0.432,0,0.871-0.038,1.311-0.115c4.079-0.719,6.803-4.609,6.084-8.688
	l-1.353-7.676c2.173-0.99,3.838-2.995,4.284-5.524C178.28,121.533,175.556,117.644,171.477,116.924z M337.796,163.612
	c3.533-0.623,5.892-3.992,5.269-7.524c-0.623-3.533-3.992-5.892-7.525-5.269c-3.533,0.623-5.892,3.992-5.269,7.524
	C330.894,161.876,334.263,164.235,337.796,163.612z M366.786,255.569c2.67,0,5.384-0.232,8.114-0.713
	c11.271-1.988,21.188-7.893,27.927-16.628c6.898-8.943,9.658-19.758,7.772-30.455c-3.847-21.813-26.121-36.18-49.648-32.034
	c-11.271,1.988-21.188,7.893-27.927,16.628c-6.898,8.943-9.658,19.758-7.772,30.455
	C328.652,242.104,346.449,255.569,366.786,255.569z M344.9,201.528c4.449-5.768,11.074-9.681,18.654-11.018
	c1.862-0.329,3.71-0.486,5.525-0.486c13.186,0,24.629,8.34,26.747,20.353c1.145,6.491-0.587,13.127-4.877,18.689
	c-4.449,5.768-11.074,9.681-18.654,11.018c-15.389,2.713-29.863-6.2-32.272-19.866C338.879,213.727,340.611,207.089,344.9,201.528z
	 M378.56,156.424c3.533-0.623,5.892-3.992,5.269-7.525c-0.623-3.533-3.992-5.891-7.524-5.268c-3.533,0.623-5.892,3.992-5.269,7.524
	C371.659,154.687,375.027,157.047,378.56,156.424z"
    />
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
</template>
